import EventLogger from './EventLogger';

export default EventLogger;
